import { useEffect, useState } from "react";
import { Hourglass } from "lucide-react";

const fmt = (s) => {
  const m = Math.floor(s / 60);
  const r = s % 60;
  return m > 0 ? `${m}m ${String(r).padStart(2, "0")}s` : `${r}s`;
};

export const CooldownNotice = ({ until, onExpire }) => {
  const [left, setLeft] = useState(() => Math.max(0, Math.ceil((until - Date.now()) / 1000)));

  useEffect(() => {
    const id = setInterval(() => {
      const s = Math.max(0, Math.ceil((until - Date.now()) / 1000));
      setLeft(s);
      if (s <= 0) {
        clearInterval(id);
        onExpire?.();
      }
    }, 1000);
    return () => clearInterval(id);
  }, [until, onExpire]);

  return (
    <div
      data-testid="cooldown-notice"
      className="plate-frame card-ink mt-8 max-w-lg mx-auto p-5 sm:p-6 text-left flex gap-4 items-start"
    >
      <span className="grid place-items-center h-10 w-10 shrink-0 rounded-full border border-primary/60 text-primary">
        <Hourglass className="h-4 w-4 animate-pulse" strokeWidth={1.6} />
      </span>
      <div>
        <p className="font-display text-xl leading-tight">
          Atlas needs a <span className="italic text-primary">moment</span>.
        </p>
        <p className="mt-1.5 text-sm text-muted-foreground leading-relaxed">
          You’ve charted quite a few routes this hour. The ink dries and the map
          reopens in{" "}
          <span data-testid="cooldown-remaining" className="numeral text-primary font-semibold">
            {fmt(left)}
          </span>
          .
        </p>
      </div>
    </div>
  );
};
